import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { INFO_CONTENT } from '../services/constants';
import { RiskMatrix } from './RiskMatrix';

interface Props {
  infoKey: string | null;
  onClose: () => void;
}

const useStyles = makeStyles({
  body: {
    fontSize: '13px',
    color: tokens.colorNeutralForeground2,
    lineHeight: 1.6,
    '& p': { marginBottom: '8px' },
    '& ul': { marginLeft: '18px', marginBottom: '8px' },
    '& li': { marginBottom: '4px', fontSize: '12.5px' },
    '& strong': { color: '#6F0F12', fontWeight: 600 },
  },
});

export function InfoModal({ infoKey, onClose }: Props) {
  const styles = useStyles();
  const content = infoKey ? INFO_CONTENT[infoKey] : null;
  const open = !!content;

  return (
    <Dialog
      open={open}
      onOpenChange={(_, data) => { if (!data.open) onClose(); }}
      modalType="modal"
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{content?.title || ''}</DialogTitle>
          <DialogContent>
            {content?.body === '__RISK_MATRIX__' ? (
              <RiskMatrix />
            ) : (
              <div
                className={styles.body}
                dangerouslySetInnerHTML={{ __html: content?.body || '' }}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onClose}>Got it</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
